//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: 'Loading',
    data() {
      return {
        showValue: false,
      };
    },
    props: {
      value: Boolean,
      useSvg: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'blink',
      },
    },
    watch: {
      value(val) {
        this.showValue = val;
      },
      showValue(val) {
        this.$emit('input', val);
      },
    },
    created() {
      if (this.value) {
        this.showValue = this.value;
      }
    },
  };



// WEBPACK FOOTER //
// ./src/components/commons/Loading/index.vue